import React from "react";
import { Link } from "react-router-dom";
import { Mail, Heart } from "lucide-react";
import { ASSETS, LINKS, BRAND } from "@/lib/brand";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative bg-paula-ink text-white pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 rounded-full bg-white grid place-items-center overflow-hidden">
                <img
                  src={ASSETS.paulaCharacter}
                  alt="Paula"
                  className="w-11 h-11 object-contain"
                />
              </div>
              <div>
                <div className="font-display font-bold text-xl">
                  Pinguin Paula
                </div>
                <div className="text-xs uppercase tracking-widest text-white/60">
                  Bleib cool — das kannst auch Du!
                </div>
              </div>
            </div>
            <p className="text-white/70 leading-relaxed max-w-sm">
              Ein Erste-Hilfe-Ausmalbuch von {BRAND.author} — Sicherheitsfachfrau
              (§34a GewO) und alleinerziehende Mama aus Solingen. Für Kinder,
              die Helden werden — und für alle, die sie dabei begleiten.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-white/60 mb-4">
              Navigation
            </div>
            <ul className="space-y-2.5 text-white/85">
              <li><a href="#mission" className="hover:text-paula-yellow">Mission</a></li>
              <li><a href="#paula" className="hover:text-paula-yellow">Wer ist Paula?</a></li>
              <li><a href="#buch" className="hover:text-paula-yellow">Buch</a></li>
              <li><a href="#schulen" className="hover:text-paula-yellow">Für Schulen</a></li>
              <li><a href="#foerderer" className="hover:text-paula-yellow">Für Förderer</a></li>
              <li><a href="#shop" className="hover:text-paula-yellow">Shop</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-widest text-white/60 mb-4">
              Kontakt
            </div>
            <a
              href={`mailto:${LINKS.email}`}
              data-testid="footer-email"
              className="inline-flex items-center gap-2 text-white hover:text-paula-yellow font-display font-semibold text-base break-all"
            >
              <Mail size={18} className="flex-shrink-0" />
              {LINKS.email}
            </a>
            <div className="mt-6 text-sm text-white/70 leading-relaxed">
              {BRAND.author}
              <br />
              Autorin · Sicherheitsfachfrau (§34a GewO)
              <br />
              Alleinerziehende Mama
              <br />
              {BRAND.address.street}, {BRAND.address.city}
              <br />
              ISBN: {BRAND.isbn}
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
              <a
                href={LINKS.shop}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
              >
                Shopify
              </a>
              <a
                href={LINKS.amazon}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
              >
                Amazon.de
              </a>
              <a
                href={LINKS.radioRsg}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
              >
                Radio RSG
              </a>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="py-6 my-2 px-5 rounded-2xl bg-white/5 border border-white/10 text-xs text-white/70 leading-relaxed">
          <span className="font-semibold text-white/90">Wichtiger Hinweis:</span>{" "}
          Dieses Buch ersetzt keinen Erste-Hilfe-Kurs. Alle Hinweise sind nach
          bestem Wissen erstellt. Für die praktische Umsetzung übernimmt die
          Autorin keine Haftung.
        </div>

        <div className="pt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-sm text-white/60">
          <div className="flex items-center gap-2">
            Mit <Heart size={14} className="text-paula-red fill-paula-red" /> für
            Kinder gemacht · {BRAND.copyright}
          </div>
          <div className="flex gap-6 flex-wrap">
            <Link
              to="/impressum"
              data-testid="footer-impressum"
              className="hover:text-white"
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              data-testid="footer-privacy"
              className="hover:text-white"
            >
              Datenschutz
            </Link>
            <a
              href={`mailto:${LINKS.email}`}
              data-testid="footer-contact"
              className="hover:text-white"
            >
              Kontakt
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
